export interface IMessageInput {
    Id: number,
    CreatedById: number,
    MessageDescription: string,
    ObjectId: number,
    ObjectTypeId: number,
    MessageGroupId: number,
    ExchangeId: number,
    RecipientId: number,
    TaggedPropertyId: number[],
    IsOnlyForUser: boolean
}

export class MessageSearchInputModel {
    UserId: number;
    UserRoleId: number;
    MessageTypeId: number;
    Search: string;
    CurrentPage: number;
    Count: number;
    ObjectId: number;
    ObjectTypeId: number;
    MessageGroupId: number;
    ExchangeId: number;
    IsFav: boolean;
}

export class MessageFollowInputModel {
    UserId: number;
    LoggedInUserId: number;
    MessageGroupId: number;
    IsFollow: boolean;

}